<template>
  <div class="index-page container">
    <n-card>
      <n-divide class="table-tools">
        <div></div>
        <n-button @click="$router.push({name: 'teachers.create'})">Добавить учителя</n-button>
      </n-divide>
  
      <n-table :data="data" :columns="columns" :loading="$var('load')">
        <template #image="{item}">
          <n-image centered :src="item.image" />
        </template>
        <template #tools="{item}">
          <n-button icon="eye" flat round @click="$router.push({name: 'teachers.edit', params: { id: item.id, }})" />
        </template>
      </n-table>

    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'image', title: 'Фото', },
      { name: 'title', title: 'Имя', },
      { name: 'direction', title: 'Направление', },
      { name: 'tools', title: '', },
    ],
  }),
  mounted() {
    this.loadModels()
  },
  methods: {
    loadModels() {
      this.$var('load', true)
      $api.app.teachers.get().then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 150px;
    --n-image-height: 150px;
  }
</style>
